import { type ReactNode } from 'react';

import classNames from '@/utils/classnames';

interface SidebarProps {
  /** Pinned to the top (brand/switcher, search…). */
  header?: ReactNode;
  /** The nav. Sits below the header; a flexible spacer pushes the footer down. */
  children: ReactNode;
  /** Pinned to the bottom (user menu, theme toggle…). */
  footer?: ReactNode;
  className?: string;
}

/** The shared 248px sidebar container — header / nav / footer slots on the sunken canvas. */
export function Sidebar({ header, children, footer, className }: SidebarProps) {
  return (
    <aside className={classNames('flex w-62 shrink-0 flex-col gap-4 bg-sunken px-2.5 py-3', className)}>
      {header}
      {children}
      <div className="flex-1" />
      {footer}
    </aside>
  );
}
